frappe.provide('webcommerce.navbar');

document.addEventListener('DOMContentLoaded', function() {
    webcommerce.navbar.init();
});

webcommerce.navbar = {
    init: function() {
        this.setupMobileToggle();
        this.setupScrollBehavior();
        this.setupClickOutside();
    },

    setupMobileToggle: function() {
        const toggleButton = document.querySelector('.navbar-toggler');
        const navbarCollapse = document.querySelector('.navbar-collapse');

        if (toggleButton && navbarCollapse) {
            toggleButton.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';

                if (isExpanded) {
                    webcommerce.navbar.closeNavbar();
                } else {
                    webcommerce.navbar.openNavbar();
                }
            });
        }
    },

    openNavbar: function() {
        const toggleButton = document.querySelector('.navbar-toggler');
        const navbarCollapse = document.querySelector('.navbar-collapse');

        if (toggleButton && navbarCollapse) {
            toggleButton.setAttribute('aria-expanded', 'true');
            navbarCollapse.classList.add('show');
            document.body.classList.add('navbar-open');
        }
    },

    closeNavbar: function() {
        const toggleButton = document.querySelector('.navbar-toggler');
        const navbarCollapse = document.querySelector('.navbar-collapse');

        if (toggleButton && navbarCollapse) {
            toggleButton.setAttribute('aria-expanded', 'false');
            navbarCollapse.classList.remove('show');
            document.body.classList.remove('navbar-open');
        }
    },

    setupClickOutside: function() {
        document.addEventListener('click', function(e) {
            const navbar = document.querySelector('.webcommerce-navbar');
            const navbarCollapse = document.querySelector('.navbar-collapse');

            if (navbar && navbarCollapse && navbarCollapse.classList.contains('show')) {
                if (!navbar.contains(e.target)) {
                    webcommerce.navbar.closeNavbar();
                }
            }
        });
    },

    setupScrollBehavior: function() {
        // 
    }
};